<template>
  <div class="shop_mobile">
    <transition name="slide-fade">
      <top_mobile v-show="topshow"></top_mobile>
    </transition>
    <div style="background: #397ea9; height: 42px"></div>
    <div class="shop-top">
      <div class="search">
        <van-search
          v-model="keyword"
          placeholder="搜索"
          @search="searchShop(1)"
          @cancel="searchShop(1)"
        />
      </div>
      <div class="carAndXin">
        <div class="dd">
          <div class="psf">
            <img
              src="../../public/statics/img/mobile/car.png"
              @click="toshoucang(1)"
              alt=""
            />
            <!-- <img
                    src="../../public/statics/img/shop/tip.png"
                    alt=""
                    class="ps"
                  /> -->
            <p>{{ nums.good_count }}</p>
          </div>
        </div>
        <div class="dd">
          <div class="psf">
            <img
              src="../../public/statics/img/mobile/xin.png"
              @click="toshoucang(2)"
              alt=""
            />

            <p>{{ nums.collect_count }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="shop-center">
      <div class="shop-content">
        <img
          src="../../public/statics/img/shop/bannners.png"
          alt=""
          style="width: 100%"
        />
      </div>
      <div class="center-search">
        <div class="types" @click="changepopula">
          <div>人气</div>
          <div class="upAndDown">
            <img src="../../public/statics/img/shop/top.png" class="img1" />
            <img src="../../public/statics/img/shop/top.png" />
          </div>
        </div>
        <div class="types" @click="changesales">
          <div>销量</div>
          <div class="upAndDown">
            <img src="../../public/statics/img/shop/top.png" class="img1" />
            <img src="../../public/statics/img/shop/top.png" />
          </div>
        </div>
        <div class="types" @click="changeprices">
          <div>价格</div>
          <div class="upAndDown">
            <img src="../../public/statics/img/shop/top.png" class="img1" />
            <img src="../../public/statics/img/shop/top.png" />
          </div>
        </div>
        <div class="type" @click="opendraw">
          <div>筛选</div>
          <div class="upAndDown">
            <img
              src="../../public/statics/img/mobile/xuan.png"
              style="width: 0.6rem; height: 0.8rem"
            />
          </div>
        </div>
      </div>
      <div class="center-dec">
        <div
          class="detailone shadow"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <div class="one-top" @click="todetail(item.goods_id)">
            <img :src="item.image" alt="" v-if="item.image != ''" />
            <img src="../../public/statics/img/shop/none.png" alt="" v-else />
          </div>
          <div class="one-contnt-top" @click="todetail(item.goods_id)">
            <span>￥</span>{{ item.price }}
          </div>
          <div class="one-contnt-bottom" @click="todetail(item.goods_id)">
            {{ item.goods_name }}
          </div>
          <div class="one-bottom">
            <div
              class="search-btn1"
              v-if="item.is_collect == 0"
              @click="shoucang(item.goods_id)"
            >
              <img src="../../public/statics/img/mobile/xin3.png" alt="" />
              <div>收藏</div>
            </div>
            <div
              class="search-btn1"
              v-if="item.is_collect == 1"
              @click="shoucang1(item.goods_id)"
              v-preventClick
            >
              <img src="../../public/statics/img/mobile/xin2.png" alt="" />
              <div>收藏</div>
            </div>
            <div
              class="search-btn2"
              @click="addcar(item.goods_id)"
              v-preventClick
            >
              <img src="../../public/statics/img/shop/car1.png" alt="" />
              <div>加入购物车</div>
            </div>
          </div>
        </div>
        <div
          v-show="this.listLength < this.allLength"
          @click="getmore"
          v-preventClick
          class="more"
        >
          加载更多
        </div>
      </div>
      <van-popup
        v-model="show"
        position="right"
        :style="{ height: '101%', width: '70%', maxHeight: '101%' }"
      >
        <div class="popup">
          <div class="prices">
            <div class="price">价格区间</div>
            <div>
              <el-input
                style="width: 5rem; height: 3rem"
                placeholder="最低价"
                v-model="minPrice"
              ></el-input>
              --
              <el-input
                style="width: 5rem; height: 3rem"
                placeholder="最高价"
                v-model="maxPrice"
              ></el-input>
            </div>
          </div>
          <div class="area">
            <div>区间</div>
            <div>
              <span :class="moren == true ? 'active' : ''" @click="changemoren"
                >默认</span
              >
              <span
                :class="
                  popularOrder == 'desc' || popularOrder == 'asc'
                    ? 'active'
                    : ''
                "
                @click="changepopula"
                >人气优先</span
              >
              <span
                :class="
                  salesOrder == 'desc' || salesOrder == 'asc' ? 'active' : ''
                "
                @click="changesales"
                >销量优先</span
              >
            </div>
          </div>
          <div class="other">
            <div>其他（可多选）</div>
            <div>
              <span
                :class="selected == 1 ? 'active' : ''"
                @click="changeSelected"
                >行家精选</span
              >
              <span
                :class="adequate == 1 ? 'active' : ''"
                @click="changeAdequate"
              >
                库存充足</span
              >
            </div>
          </div>
        </div>
        <div class="conAndReset">
          <el-button class="reSet" @click="changemoren">重置</el-button>
          <el-button class="confirm" @click="closeShow">确定</el-button>
        </div>
      </van-popup>
    </div>
    <botmob></botmob>
  </div>
</template>

<script>
import top_mobile from "../components/top_mobile";
import botmob from "../components/botmobile";
import { auth, anth } from "../request/api";
import "../../public/statics/css/base.css";

import { Toast } from "vant";
export default {
  name: "index_mobile",
  data() {
    return {
      topshow: true,
      newdata: [],
      listLength: 1,
      allLength: 0,
      show: false,
      page: 1,
      moren: true,
      keyword: "",
      popularOrder: "",
      salesOrder: "",
      priceOrder: "",
      minPrice: "",
      maxPrice: "",
      selected: 0,
      adequate: 0,
      dataList: [],
      nums: {
        collect_count: "",
        good_count: "",
      },
    };
  },
  watch: {},
  components: {
    top_mobile,
    botmob,
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScrollx, true);
    this.getdataList();
    this.getNum();
  },
  methods: {
    getNum() {
      let url = "/v1/shop/my/count";
      let data = {};
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.nums.collect_count = res.data.data.collect_count;
          this.nums.good_count = res.data.data.good_count;
        }else{
            Toast({
              message: res.data.msg,
              position: "center",
            });
        }
      });
    },
    getdataList() {
      let url = "/v1/shop/goods/list";
      let data = {
        page: this.page,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          // console.log(res);
          this.dataList = this.dataList.concat(res.data.data.list);
          this.listLength = res.data.data.current_page;
          this.allLength = res.data.data.pageall;
        }else{
            Toast({
              message: res.data.msg,
              position: "center",
            });
        }
      });
    },
    handleScrollx() {
      if (window.pageYOffset > 85) {
        this.topshow = false;
      } else {
        this.topshow = true;
      }
    },
    toshoucang(e) {
      let url = "/v1/shop/my/cart";
      let data = {
        // page: 1,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$router.push({
            path: "/shoucang_mobile",
            query: {
              types: e,
            },
          });
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },
    // toshoucang(){

    // },

    shoucang(e) {
      let url = "/v1/shop/my/addCollect";
      let data = {
        id: e,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          Toast({
            message: "收藏成功",
            position: "center",
          });
          this.searchShop(this.page_now);
          this.getNum();
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
      // this.dataList[e].isshoucang = true;
    },
    shoucang1(e) {
      let url = "/v1/shop/my/delCollect";
      let data = {
        id: e,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          Toast({
            message: "取消收藏",
            position: "center",
          });
          this.searchShop(this.page_now);

          this.getNum();
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },
    todetail(e) {
      this.$router.push({
        path: "/detail_mobile",
        query: {
          id: e,
        },
      });
    },
    closeShow() {
      this.show = false;
      this.dataList = [];
      this.searchShop(1);
    },
    changemoren() {
      this.dataList = [];

      this.moren = true;
      this.salesOrder = "";
      this.popularOrder = "";
      this.priceOrder = "";
      this.maxPrice = "";
      this.minPrice = "";
      this.selected = 0;
      this.adequate = 0;
      this.show = false;

      this.searchShop(1);
    },
    changepopula() {
      this.dataList = [];

      this.moren = false;
      this.salesOrder = "";
      this.priceOrder = "";
      if (this.popularOrder == "desc") {
        this.popularOrder = "asc";
      } else if (this.popularOrder == "asc") {
        this.popularOrder = "desc";
      } else {
        this.popularOrder = "desc";
      }
      this.searchShop(1);
    },
    changesales() {
      this.dataList = [];

      this.moren = false;
      this.popularOrder = "";
      this.priceOrder = "";
      if (this.salesOrder == "desc") {
        this.salesOrder = "asc";
      } else if (this.salesOrder == "asc") {
        this.salesOrder = "desc";
      } else {
        this.salesOrder = "desc";
      }
      this.searchShop(1);
    },
    changeprices() {
      this.dataList = [];
      this.moren = false;
      this.popularOrder = "";
      this.salesOrder = "";
      if (this.priceOrder == "desc") {
        this.priceOrder = "asc";
      } else if (this.priceOrder == "asc") {
        this.priceOrder = "desc";
      } else {
        this.priceOrder = "desc";
      }
      this.searchShop(1);
    },
    searchShop(pages) {
      // data = {};
      this.allLength = 0;
      if (pages != "undefined") {
        this.page = pages;
      } else {
        this.page = 1;
      }
      // console.log(pagees);
      let url = "/v1/shop/goods/list";
      let selecteds = 0;
      if (this.selected == 1) {
        selecteds = 1;
      } else {
        selecteds = 0;
      }
      let adequates = 0;
      if (this.adequate == 1) {
        adequates = 1;
      } else {
        adequates = 0;
      }
      let data = {
        page: this.page,
        keyword: this.keyword,
        popularOrder: this.popularOrder,
        salesOrder: this.salesOrder,
        priceOrder: this.priceOrder,
        price_min: this.minPrice,
        price_max: this.maxPrice,
        selected: selecteds,
        adequate: adequates,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.dataList = this.dataList.concat(res.data.data.list);
          this.listLength = res.data.data.current_page;
          this.allLength = res.data.data.pageall;
        }else{}
          Toast({
              message: res.data.msg,
              position: "center",
            });
      });
    },
    changeSelected() {
      this.dataList = [];

      if (this.selected == 1) {
        this.selected = 0;
      } else {
        this.selected = 1;
      }
      this.searchShop(1);
    },
    changeAdequate() {
      this.dataList = [];

      if (this.adequate == 1) {
        this.adequate = 0;
      } else {
        this.adequate = 1;
      }
      this.searchShop(1);
    },
    addcar(e) {
      let url = "/v1/shop/my/addCart";
      let data = {
        id: e,
        num: 1,
        // product_attr_unique: i,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          Toast({
            message: "加入成功",
            position: "center",
          });
          this.searchShop(this.page_now);

          this.getNum();
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },
    getmore() {
      if (this.page != "undefined") {
        this.page = Number(this.page) + 1;
        console.log(this.page);
        this.searchShop(this.page);
      }
    },
    opendraw() {
      this.show = true;
    },
  },
};
</script>

<style scoped lang='scss'>
.shop_mobile {
  width: 100%;
  height: 100vh;
  .shop-top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .search {
      width: 26rem;
      /deep/ .van-search__content {
        border-radius: 5rem;
      }
    }
    .carAndXin {
      width: 5rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .dd {
        width: 2.5rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .psf {
          display: flex;
          align-items: flex-start;
          width: 18px;
          height: 20px;
          margin-left: 2px;

          background-repeat: no-repeat;
          justify-content: center;
          position: relative;

          p {
            position: absolute;
            right: -10px;
            top: -7px;
            // width: 22px;
            // font-size: 12px;
            // height: 18px;
            padding: 0px 4px 0px 4px;
            background-image: url("../../public/statics/img/shop/tip.png");
            background-size: 100% 100%;
            text-align: center;
            font-family: PingFang SC;
            font-weight: bold;
            color: #fff;
            border-radius: 10%;
            opacity: 1;
          }
        }
      }
    }
  }
  .shop-center {
    padding-bottom: 4rem;
    box-sizing: border-box;
    .shop-content {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 2% 4%;
      background-color: rgba(245, 247, 251, 1);
      box-sizing: border-box;
      // height: 8rem;
      margin-bottom: 1rem;
      overflow-y: hidden;
      .content-left {
        width: 24rem;

        overflow-x: hidden;
        // height: 0;
        // padding-top: 100%;
        // overflow: hidden;
        // background-position: center center;
        // background-repeat: no-repeat;
        // background-size: cover;
        // -webkit-background-size: cover;
        // -moz-background-size: cover;
      }
      .content-right {
        margin-left: 0.2rem;
        // width: calc(100% - 20rem - 0.2rem);
        overflow-x: hidden;
        // height: 0;
        // padding-top: 100%;
        // overflow: hidden;
        // background-position: center center;
        // background-repeat: no-repeat;
        // background-size: cover;
        // -webkit-background-size: cover;
        // -moz-background-size: cover;
      }
    }
    .center-search {
      display: flex;
      justify-content: start;
      align-items: center;
      margin-bottom: 1rem;
      .types {
        width: 25%;
        font-size: 1rem;
        font-family: PingFang SC;

        color: #333333;
        opacity: 1;
        display: flex;
        justify-content: center;
        position: relative;
        font-weight: bold;
        .upAndDown {
          margin-left: 0.4rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 0.6rem;
          img {
            width: 0.5rem;
            height: 0.3rem;
          }
          .img1 {
            margin-bottom: 0.15rem;
            transform: rotate(180deg);
          }
        }
      }
      .types:after {
        content: "";
        // width: calc(100% + 40px);
        width: 2px;
        // height: 12px;
        border-bottom: 14px solid #999;
        position: absolute;
        bottom: 2px;
        right: 0px;
      }
      .type {
        width: 25%;
        font-size: 1rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        opacity: 1;
        display: flex;
        justify-content: center;
        .upAndDown {
          margin-left: 0.4rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 0.6rem;
          img {
            width: 0.5rem;
            height: 0.3rem;
          }
          .img1 {
            margin-bottom: 0.15rem;
            transform: rotate(180deg);
          }
        }
      }
    }
    .center-dec {
      display: flex;
      justify-content: start;
      flex-wrap: wrap;
      padding: 0 4%;
      box-sizing: border-box;
      .detailone {
        width: 50%;
        display: inline-block;
        padding: 0.3rem 0.55rem;
        box-sizing: border-box;
        box-sizing: border-box;
        background-color: rgba(255, 255, 255, 0.28);

        .one-top {
          display: flex;
          align-self: center;
          justify-content: center;
          padding: 0.42rem 0rem;
          box-sizing: border-box;
          width: 100%;
          height: 10rem;
          img {
            width: 100%;
          }
        }
        .one-contnt-top {
          margin-top: 0.5rem;
          // padding: 0.1rem 0;
          box-sizing: border-box;
          font-size: 1rem;
          text-align: left;
          font-family: PingFang SC;
          font-weight: bold;
          line-height: 1.5rem;
          color: #ff9a26;
          opacity: 1;
          span {
            font-size: 0.8rem;
          }
        }
        .one-contnt-bottom {
          margin-top: 0.2rem;
          font-size: 0.8rem;
          text-align: left;
          font-family: PingFang SC;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          height: 3rem;
          -webkit-box-orient: vertical;
          line-height: 1.5rem;
          color: #333333;
          opacity: 1;
        }
        .one-bottom {
          margin-top: 0.5rem;
          display: flex;
          justify-content: space-around;
          align-items: center;
          // border: 1px solid #707070;
          font-family: PingFang SC;
          font-weight: bold;
          background: #f5f7fb;
          div {
            font-size: 0.8rem;
            line-height: 1.5rem;
          }
          .top-right {
            padding: 0.1rem 0.43rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            background: #ffffff;
            border: 2px solid #397ea9;
            opacity: 1;
            box-sizing: border-box;
            // width: 80px;
          }
          .search-btn1 {
            display: flex;
            align-items: center;
            padding: 0.075rem 0.2rem;
            box-sizing: border-box;
            color: #999;
            img {
              margin-right: 5px;
              width: 1rem;
              height: 0.85rem;
            }
            // border-right: 1px solid #707070;
          }
          .search-btn2 {
            display: flex;
            align-items: center;
            color: rgba(255, 154, 38, 1);
            // padding: 5px 20px;
            padding: 0.075rem 0.2rem;
            // height: 22px;
            // font-size: 16px;
            // font-family: PingFang SC;

            // line-height: 21px;
            // color: #FF9A26;
            // opacity: 1;
            img {
              margin-right: 5px;
              width: 1rem;
              height: 0.8rem;
            }
          }
        }
      }
      .more {
        width: 100%;
        text-align: center;
        height: 1rem;
        margin: 1rem 0;
        line-height: 1rem;
        font-size: 0.9rem;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 0px;
        color: #999999;
        opacity: 1;
      }
    }
  }
  .popup {
    padding: 2rem 1rem;
    height: calc(98% - 2rem);
    box-sizing: border-box;
    font-family: PingFang SC;
    font-weight: bold;
    .prices {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: flex-start;
      .price {
        font-size: 1rem;
        font-family: PingFang SC;

        line-height: 1.5rem;
        color: #333333;
        opacity: 1;
        margin-bottom: 1rem;
      }
    }
    .area {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: flex-start;
      margin-top: 1rem;
      font-size: 1rem;
      font-family: PingFang SC;

      line-height: 1.5rem;
      color: #333333;
      opacity: 1;
      margin-bottom: 1rem;
      span {
        display: inline-block;
        margin-top: 1rem;
        width: 4rem;
        height: 2rem;
        line-height: 2rem;
        background: #efefef;
        opacity: 1;
        border-radius: 2px;
        font-size: 0.6rem;
        font-family: PingFang SC;
        color: #9d9d9d;
        margin-right: 0.5rem;
      }
    }
    .active {
      background-color: rgba(255, 183, 183, 1) !important;
      color: rgba(255, 106, 106, 1) !important;
    }
    .other {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: flex-start;
      margin-top: 2rem;
      font-size: 1rem;
      font-family: PingFang SC;

      line-height: 1.5rem;
      color: #333333;
      opacity: 1;
      margin-bottom: 1rem;
      span {
        display: inline-block;
        margin-top: 1rem;
        width: 4rem;
        height: 2rem;
        line-height: 2rem;
        background: #efefef;
        opacity: 1;
        border-radius: 2px;
        font-size: 0.6rem;
        font-family: PingFang SC;
        color: #9d9d9d;
        margin-right: 0.5rem;
      }
    }

    /deep/ .el-input__inner {
      height: 2rem;
      line-height: 2rem;
      border: none;
      border-radius: 0;
      background-color: rgba(239, 239, 239, 1);
    }
  }
  .conAndReset {
    box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.16);
    display: flex;
    align-items: center;
    font-size: 1.5rem;

    justify-content: flex-start;
    span {
      font-family: PingFang SC;
      font-weight: bold;
    }
    .reSet {
      width: 50%;
      // height: 2rem;
      background: #ffffff;
      box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 0px;
    }

    .confirm {
      width: 50%;
      background: #ff9a26;
      box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.16);
      opacity: 1;
      color: #fff;
      border-radius: 0px;
    }
  }
}
</style>